import React, { useEffect, useState, useRef } from "react";
import Slider from "react-slick";
import { api, baseURL, customerReqConfig } from "../../src/include/api";
import { useNotification } from "../Toast/ToastProvider";

const Sponsored = (props) => {
    const [bannerSlides, setBannerSlides] = useState([]);
    const [fetchLoading, setFetchLoading] = useState(true);
    const [hoveredIndices, setHoveredIndices] = useState({});
    const toast = useNotification();
    const sliderRef = useRef(null);

    const fetchBannerSlides = () => {
        setFetchLoading(true);
        api
            .get("/slide_show/", customerReqConfig())
            .then((response) => {
                if (response.status === 200) {
                    const filteredSlides = response.data.data.filter(
                        slide => slide.status === 'active' && slide.type === 'sponsored'
                    );
                    setBannerSlides(filteredSlides.slice(0, 6));
                }
            })
            .catch((error) => {
                console.error("Error fetching banner slides", error);
                toast({ type: "error", message: "Failed to load sponsored banners." });
                setBannerSlides([]);
            })
            .finally(() => {
                setFetchLoading(false);
            });
    };

    useEffect(() => {
        fetchBannerSlides();
    }, []);

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 1000,
        slidesToShow: Math.min(3, bannerSlides.length),
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: true,
        responsive: [
            { breakpoint: 1399, settings: { slidesToShow: 3 } },
            { breakpoint: 1199, settings: { slidesToShow: 3 } },
            { breakpoint: 575, settings: { slidesToShow: 1 } },
        ],
    };

    return (
        <section className="top-selling pt-16 mb-32">
            <div className="container container-lg">
                <div className="border border-gray-200 p-24 rounded-16">
                    <div className="section-heading mb-24">
                        <div className="flex-between flex-wrap gap-8">
                            <h5 className="text-xl mt-16 fw-bold">Sponsored</h5>
                            <div className="flex-align mr-point gap-16 ms-80">
                                <div className="flex-align gap-8 ">
                                    <button
                                        type="button"
                                        onClick={() => sliderRef.current?.slickPrev()}
                                        style={{
                                            width: "48px",
                                            height: "48px",
                                            borderRadius: "50%",
                                            backgroundColor: "white",
                                            border: "1px solid #cbd5e1",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            transition: "background-color 0.3s, color 0.3s",
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = "#FA6800";
                                            e.currentTarget.style.color = "white";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = "white";
                                            e.currentTarget.style.color = "black";
                                        }}
                                        aria-label="Previous"
                                    >
                                        <i className="ph ph-caret-left text-xl d-flex" style={{ margin: 0, lineHeight: 1 }} />
                                    </button>

                                    <button
                                        type="button"
                                        onClick={() => sliderRef.current?.slickNext()}
                                        style={{
                                            width: "48px",
                                            height: "48px",
                                            borderRadius: "50%",
                                            backgroundColor: "white",
                                            border: "1px solid #cbd5e1",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            transition: "background-color 0.3s, color 0.3s",
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = "#FA6800";
                                            e.currentTarget.style.color = "white";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = "white";
                                            e.currentTarget.style.color = "black";
                                        }}
                                        aria-label="Next"
                                    >
                                        <i className="ph ph-caret-right text-xl" style={{ margin: 0, lineHeight: 1 }} />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="deals-week-slider arrow-style-two position-relative">
                        {bannerSlides.length > 0 ? (
                            <Slider {...settings} ref={sliderRef} key={bannerSlides.length}>
                                {bannerSlides.map((slide, index) => {
                                    const imageUrl = slide.imageUrl ? `${baseURL}/${slide.imageUrl}` : "/placeholder-image.jpg";
                                    const isHovered = hoveredIndices[index] || false;

                                    return (
                                        <div
                                            key={index}
                                            className="sponsored-card h-100 border border-gray-100 hover-border-main-600 rounded-16 overflow-hidden position-relative"
                                            style={{
                                                height: '100%',
                                                backgroundColor: 'white',
                                                transition: 'background-color 0.3s ease',
                                                cursor: 'pointer',
                                                position: 'relative'
                                            }}
                                            onMouseEnter={() => setHoveredIndices(prev => ({ ...prev, [index]: true }))}
                                            onMouseLeave={() => setHoveredIndices(prev => ({ ...prev, [index]: false }))}
                                        >
                                            <img
                                                src={imageUrl}
                                                alt={slide.title || "Sponsored Banner"}
                                                className="w-100 object-cover"
                                                style={{
                                                    aspectRatio: "4 / 2",
                                                    height: "80%",
                                                    display: 'block',
                                                    position: 'relative',
                                                    zIndex: 10
                                                }}
                                            />

                                            <footer
                                                className="position-absolute bottom-0 w-100"
                                                style={{
                                                    backgroundColor: isHovered ? '#ff6600' : '#e2e8f0',
                                                    color: isHovered ? 'white' : 'black',
                                                    borderBottomLeftRadius: "16px",
                                                    borderBottomRightRadius: "16px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    padding: "12px 0",
                                                    transition: "background-color 0.3s ease, color 0.3s ease",
                                                    cursor: "pointer"
                                                }}
                                            >
                                                <a
                                                    href={slide.linkUrl}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="w-100 text-decoration-none d-flex align-items-center justify-content-center gap-2"
                                                    style={{
                                                        cursor: "pointer",
                                                        color: 'inherit',
                                                        textDecoration: 'none',
                                                        fontWeight: 'bold',
                                                        fontSize: '0.875rem' // text-md equivalent
                                                    }}
                                                >
                                                    Shop Now

                                                </a>
                                                <i className="ph ph-arrow-right text-xl pe-16 fw-bold" style={{ fontSize: "20px", color: 'inherit' }} />
                                            </footer>
                                        </div>
                                    );
                                })}
                            </Slider>
                        ) : fetchLoading ? (
                            <div className="text-center py-5">Loading sponsored banners...</div>
                        ) : (
                            <div className="text-center py-5">No active banners to display.</div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Sponsored;